import React from 'react'
import PropTypes from 'prop-types'

export const Select = props => {
  let courseOptions = props.courses.map(obj => (
    <option value={obj.id} key={obj.id}>
      {obj.title}
    </option>
  ))

  return (
    <select
      onChange={props.handler}
      value={props.book.id}
      className="form-control"
    >
      {courseOptions}
    </select>
  )
}

Select.propTypes = {
  courses: PropTypes.array,
  handler: PropTypes.func,
  book: PropTypes.object,
}
